import React from 'react';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';

import { BackButton } from 'components/common/buttons/BackButton';
import { NotFound } from 'components/NotFound';

export const NotFoundPage: React.FC = () => {
  return (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar mode="ios">
          <IonButtons className="header">
            <BackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>ページが見つかりません</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <NotFound />
      </IonContent>
    </IonPage>
  );
};
